import { set } from 'lodash';
import { useCallback, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';

import type { Dispatch } from '@swf/core/store';
import { select } from '@swf/core/store';
import { c2lHandler } from '@swf/core/utils/c2l';

const useEmbeddedAPI = () => {
  const { token, signature, userWebId: webId } = useSelector(select.session.getLegacySession);
  const site = useSelector(select.cms.getSiteId);
  const brand = useSelector(select.cms.getBrandId);
  const playMoney = useSelector(select.currency.isPlayMoney);
  const currency = useSelector(select.currency.get);
  const isAuthenticated = useSelector(select.session.isAuthenticated);
  const authRef = useRef(isAuthenticated);
  const locale = useSelector(select.locale.get);
  const isEmbedded = useSelector(select.device.isEmbedded);
  const platform = useSelector(select.device.getPlatform);
  const history = useHistory();

  const {
    modal,
    auth,
    currency: { setPlayMoney }
  } = useDispatch<Dispatch>();

  const login = useCallback(() => modal.enqueue({ path: '/auth/login' }), [modal]);

  const execute = useCallback((path: string) => c2lHandler('/' + path, history), [history]);

  useEffect(() => {
    if (!isEmbedded) {
      set(window, 'starsweb.auth', { token, signature, webId, login, logout: auth.logout });
      set(window, 'starsweb.app', {
        locale,
        brand,
        site,
        playMoney,
        currency,
        platform,
        setPlayMoney,
        execute
      });
      set(window, 'starsweb.minigames', { sound: true });
    }
  }, [
    isEmbedded,
    auth.logout,
    brand,
    currency,
    locale,
    login,
    playMoney,
    setPlayMoney,
    execute,
    signature,
    site,
    platform,
    token,
    webId
  ]);

  useEffect(() => {
    if (authRef.current !== isAuthenticated) {
      document.dispatchEvent(new Event(isAuthenticated ? 'starslogin' : 'starslogout'));
      authRef.current = isAuthenticated;
    }
  }, [isAuthenticated]);
};

export default useEmbeddedAPI;
